<template>

  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/4 xl:w-2/4 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center ">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto" width="200dp">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">XYLO PAYSLIP</h4>
                  <p></p>
                </div>
                <br />

                <div>
                  <vs-input data-vv-validate-on="blur" v-validate="'required|min:4|max:4'" type="password"
                    name="password" icon-no-border icon="icon icon-lock" icon-pack="feather"
                    label-placeholder="Password" v-model="password" class="w-full mt-6" />
                  <span class="text-danger text-sm">{{ errors.first('password') }}</span>
                  <!--
                    <div class="flex flex-wrap justify-between my-5">
                        <router-link to="/pages/forgot-password">Forgot Password?</router-link>
                    </div>--><br />
                  <div class="flex flex-wrap justify-between mb-3">
                    <vs-button :disabled="!validateForm" @click="checkLogin()">DESCARCA FLUTURAS {{
                      filenames }}</vs-button>
                  </div>
                </div>
                <br />
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import axios from "@/axios.js";
export default {
  data() {
    return {
      filenames: 'wait',  // Assurez-vous que "filenames" est bien défini ici
      email: '',          // Assurez-vous que "email" est bien défini ici
      password: ''        // Assurez-vous que "password" est bien défini ici
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.password !== ''  // Assurez-vous que "validateForm" est bien défini ici
    }
  },
  methods: {
    downloadPayslip(generated_filename) {
      const filename = generated_filename;

      axios({
        url: `/clicksend/download/${filename}`, // Construire l'URL avec le nom de fichier
        method: 'GET',
        responseType: 'blob' // Indiquer que la réponse est un blob (fichier binaire)
      })
        .then((response) => {
          // Créer un lien temporaire pour télécharger le fichier
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename); // Nom du fichier téléchargé
          document.body.appendChild(link);
          link.click();

          // Nettoyage
          link.parentNode.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error('Error downloading the file:', error);
          alert('Erreur lors du téléchargement du fichier.');
        });
    }, async checkLogin() {
    try {
      const response = await axios.post(`/payslip/checkpin/${this.filenames}`, {
        pin: this.password
      });

      if (response.status === 200) {
        if (response.data == 'Invalid PIN')
        {
          this.$vs.notify({
          title: 'Invalid PIN',
          text: 'The PIN you entered is incorrect. Please try again.',
          color: 'danger'
        });          
        }
        else this.downloadPayslip(this.filenames);
      }
    } catch (error) {
      console.log('Error caught:', error); // Log pour vérifier que l'erreur est bien capturée

      if (error.response && error.response.status === 401) {
        this.$vs.notify({
          title: 'Invalid PIN',
          text: 'The PIN you entered is incorrect. Please try again.',
          color: 'danger'
        });
      } else if (error.response && error.response.status === 404) {
        this.$vs.notify({
          title: 'Not Found',
          text: 'No payslips found for the provided filename.',
          color: 'warning'
        });
      } else {
        this.$vs.notify({
          title: 'Error',
          text: 'An error occurred while checking the PIN. Please try again later.',
          color: 'danger'
        });
      }
    }
  },
  },
  created() {
    this.filenames = this.$route.params.filename || 'default-filename'; // Assurez-vous que "filenames" est bien mis à jour
  },
}
</script>